// extracted by mini-css-extract-plugin
export default {"WorkspaceNameContainer":"_WorkspaceNameContainer--L9Gfq","WorkspaceName":"_WorkspaceName--_iAWT"};